















import Enumerable from "linq";
import { Component, Mixins, Prop, Emit } from "vue-property-decorator";
import DropDownSelector from "./DropDownSelector.vue";
import { SingleOptionSelectableMixin, StandardOption } from "./mixins";

@Component({
  components: {
    selector: DropDownSelector,
  },
})
export default class OptionDropDownSelector extends Mixins(SingleOptionSelectableMixin) {
  @Prop({ default: false })
  isClearable: boolean;

  @Emit()
  selectorClicked(): void {}

  $refs!: {
    dropDownSelector: DropDownSelector;
  };

  get dropDownOptions(): StandardOption<any>[] {
    return Enumerable.from(this.isClearable ? [ new StandardOption<any>("未指定", null) ] : [])
      .concat(!this.options ? [] : this.options)
      .toArray();
  }

  get selectedDropDownOption(): StandardOption<any> {
    return this.findOption(this.editingSource, this.dropDownOptions);
  }

  set selectedDropDownOption(option: StandardOption<any>) {
    this.editingSource = option
      ? option.value
      : null;
  }

  setFocus(): void {
    if (this.$refs.dropDownSelector) {
      this.$refs.dropDownSelector.setFocus();
    }
  }

  onSelectorClicked() {
    this.selectorClicked();
  }
}
